// What the basis of a derived relation says about it. The pipeline writes
// the basis ("designation-prefix", "maker-pass:possessive", ...); the
// maker pass tags a maker with a quote of the article as
// "maker-pass:<basis>", and only two of its bases are not said of the
// product itself.

import { codeWords } from "./format";

// The prefix of a maker the focused second reading of the article found
const MAKER_PASS = "maker-pass:";

// The maker-pass bases under which the article never says it of this
// product: the maker is carried over from its portfolio or the family
const INHERITED_BASES = ["portfolio", "family"];

// The maker-pass basis of a derived relation; null for any other basis
const makerPassBasis = (basis: string | null | undefined): string | null =>
  basis?.startsWith(MAKER_PASS) ? basis.slice(MAKER_PASS.length) : null;

// Whether a derived relation is an inference the article does not state of
// the product: a maker read off the vendor's portfolio or the family
export const isInheritedBasis = (basis: string | null | undefined): boolean =>
  INHERITED_BASES.includes(makerPassBasis(basis) ?? "");

// The tooltip of a derived relation, in words
export const derivedBasisTitle = (basis: string | null | undefined): string => {
  const pass = makerPassBasis(basis);
  if (pass === "portfolio") {
    return "Likely: inferred from the organization's portfolio, no source states it of this product";
  }
  if (pass === "family") {
    return "Likely: inferred from the product family, no source states it of this product";
  }
  if (pass !== null) {
    return "Found by a second, focused reading of the source, which states it";
  }
  return basis
    ? `Derived from ${codeWords(basis)}: no source states it as such`
    : "Derived: no source states it as such";
};
